// @flow
import React, {Component} from 'react';
import AppsUtil from '../../../../utils/AppsUtil';
import CCDUtil from '../../../../utils/CCDUtil';
import URL from '../../../../utils/Url';
import HelpPopoverUtil from '../../../../utils/AppPicker/HelpPopoverUtil';
import './GetHelp.scss';
import {GET_HELP_STRINGS, FEEDBACK_RESPONSES, LOGGED_OUT_CAMPAIGN_ENV_NAME} from '../../../../constants/AppPicker/appPickerConstants';
import AppPickerAnalytics from '../../../../analytics/AppPickerAnalytics';
import Link from '@react/react-spectrum/Link';

type Props = {
	environment: string
};

type State = {
	feedbackResponses: Object
};

export default class Feedback extends Component<Props, State> {
	feedbackRef: ?HTMLDivElement;

	constructor(props: Props) {
		super(props);
		this.state = {
			feedbackResponses: HelpPopoverUtil.feedbackResponses,
		};
	}

	storeFeedbackResponse(response: string) {
		this.handleAnalyticsEvent(response, HelpPopoverUtil.selectedQuestion);
		const {feedbackResponses, selectedQuestion} = HelpPopoverUtil;
		feedbackResponses[selectedQuestion] = response;
		const feedback = this.state.feedbackResponses;
		feedback[selectedQuestion] = response;
		this.setState({feedbackResponses: feedback});
	}

	handleAnalyticsEvent(answer: string, questionId: string) {
		const analytics = new AppPickerAnalytics(window.ENV);
		analytics.initAnalytics();
		const event = {
			subcategory: 'Help',
			type: 'click',
			subtype: 'feedback',
			value: answer
		};
		const content = {
			id: questionId,
			name: HelpPopoverUtil.questionEngText[questionId],
			category: 'faq'
		};
		const ui = {
			view_type: analytics.getPageTypeString() // eslint-disable-line camelcase
		};
		let env;
		if (AppsUtil.isLoggedOutCampaignExp) {
			event.workflow = 'Campaign CTA';
			ui.view_type = LOGGED_OUT_CAMPAIGN_ENV_NAME; // eslint-disable-line camelcase
			event.subcategory = CCDUtil.getCampaignWorkflowSubcategory();
			env = {
				name: LOGGED_OUT_CAMPAIGN_ENV_NAME,
				version: URL.getParam('exp'),
			};
		}
		analytics.genericAnalyticEvent({
			event,
			content,
			ui,
			env
		});
	}

	getFeedBackQuestionText() {
		const intl = AppsUtil.intl;
		const {selectedQuestion} = HelpPopoverUtil;
		const {feedbackResponses} = this.state;
		if (feedbackResponses[selectedQuestion]) {
			return intl.formatMessage({id: GET_HELP_STRINGS.FEEDBACK_ACKNOWLEDGEMENT});
		}
		return intl.formatMessage({id: GET_HELP_STRINGS.FEEDBACK_QUESTION}, {
			a1: str => <Link tabIndex='0' onClick={() => this.storeFeedbackResponse(FEEDBACK_RESPONSES.POSITIVE)}>{str}</Link>,
			a2: str => <Link tabIndex='0' onClick={() => this.storeFeedbackResponse(FEEDBACK_RESPONSES.NEGATIVE)}>{str}</Link>
		});
	}

	render() {
		return (
			<div className='feedback-question' ref={r => this.feedbackRef = r}>
				{this.getFeedBackQuestionText()}
			</div>
		);
	}
}
